import { BaseSidePanel } from 'components/sidePanel';
import { ITabItem } from 'components/tab';
import React, { useEffect, useState } from 'react';
import { PuckDewarContainerView, sidePanelTitle } from './puck/constants';
import { PuckDewarInfo, SelectDewar, SelectPuck } from './puckDewarContainer';
import { useParams } from 'react-router-dom';
import {
  useFetchAllEnabledDewarsWithOccupancyByTrip,
  useFetchAllEnabledPucksWithOccupancyByTrip,
} from './puckDewarContainer/hooks';
import { CrystalDataDTO } from './constants';
import {
  useCrystals,
  useOriginalSynchTrip,
  useSelectedCrystalId,
} from 'redux/hooks/synchrotron';
import { useRMDispatch } from 'redux/hooks';
import {
  setAllCrystals,
  setIsCrystalAssignmentsDirty,
  setTripEditStatus,
} from 'redux/reducers/synchrotronTripReducer';
import ETreeNodeAccessRightNames from 'enums/ETreeNodeAccessRightNames';

const sidePanel = () => {
  const [contentView, setContentView] = useState<PuckDewarContainerView>(
    PuckDewarContainerView.PuckDewarInfoView,
  );
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [crystals, setCrystals] = useState<CrystalDataDTO[]>();

  const selectedCrystalId = useSelectedCrystalId();
  const { id } = useParams();
  const dispatch = useRMDispatch();
  const _crystals = useCrystals();
  const tripId = parseInt(id);
  useFetchAllEnabledPucksWithOccupancyByTrip(tripId);
  useFetchAllEnabledDewarsWithOccupancyByTrip(tripId);
  const synchTrip = useOriginalSynchTrip();

  const isReadOnly = synchTrip.accessRightName !== ETreeNodeAccessRightNames.Modify;

  useEffect(() => {
    setCrystals(_crystals);
  }, [_crystals]);

  useEffect(() => {
    setContentView(PuckDewarContainerView.PuckDewarInfoView);
  }, [selectedCrystalId]);

  const onCrystalContainerAssignmentsDiscardHandler = () => {
    setIsEditMode(false);
    setCrystals(_crystals);
    dispatch(setIsCrystalAssignmentsDirty(false));
  };

  const onCrystalContainerAssignmentsSaveHandler = () => {
    setIsEditMode(false);
    dispatch(
      setAllCrystals(
        crystals.map((crystal) =>
          crystal.crystalContainerAssignments.isDirty === true
            ? {
                ...crystal,
                crystalContainerAssignments: {
                  ...crystal.crystalContainerAssignments,
                  isDirty: false,
                  isUpdated: true,
                },
              }
            : crystal,
        ),
      ),
    );
    dispatch(setTripEditStatus({ isDirty: true }));
    dispatch(setIsCrystalAssignmentsDirty(false));
  };

  const tabItems_: ITabItem[] = [
    {
      content: (
        <div id="synchrotron-sidepanel-wrapper" style={{ height: 'inherit' }}>
          {contentView === PuckDewarContainerView.PuckDewarInfoView && (
            <PuckDewarInfo
              isEditMode={isEditMode}
              crystals={crystals}
              setCrystals={setCrystals}
              setIsEditMode={setIsEditMode}
              setContentView={setContentView}
              onSaveHandler={onCrystalContainerAssignmentsSaveHandler}
              onDiscardHandler={onCrystalContainerAssignmentsDiscardHandler}
              isReadOnly={isReadOnly}
            />
          )}
          {contentView === PuckDewarContainerView.SelectPuckView && (
            <SelectPuck
              crystals={crystals}
              setCrystals={setCrystals}
              setContentView={setContentView}
            />
          )}
          {contentView === PuckDewarContainerView.SelectDewarView && (
            <SelectDewar
              crystals={crystals}
              setCrystals={setCrystals}
              setContentView={setContentView}
            />
          )}
        </div>
      ),
      title: 'Puck And Dewar Option',
    },
  ];

  return <BaseSidePanel tabItems={tabItems_} headerTitle={sidePanelTitle[contentView]} />;
};

export default sidePanel;
